import { render, staticRenderFns } from "./SubjectHistory.vue?vue&type=template&id=127c46b8&"
import script from "./SubjectHistory.vue?vue&type=script&lang=js&"
export * from "./SubjectHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports